import { ISearchCriteria, SnackbarType } from 'common/interfaces';
import { IStore } from 'common/interfaces/istore';
import { StoreActions } from 'reducers/store-reducer';
import { UpdateStoreActions } from 'reducers/update-store-reducer';
import {
  getStoreById,
  getStoreList,
  getStoresForUser,
  IStoreSearchCriteria,
  postDeleteStore,
  postSearchStores,
  postUpdateStore,
} from 'services/store-service';
import { useAppDispatch } from 'setup/store';
import { useAppActions } from './app-actions';
import { getTaxByStoreId } from 'services/tax-service';
import UILogger from 'common/utils/logger';
import { TaxActions } from 'reducers/tax-reducer';
import { useTranslation } from 'react-i18next';
import { IUserSearchCriteria } from 'common/interfaces/iuser';

export const useStoreActions = () => {
  const dispatch = useAppDispatch();
  const { showSnackBar } = useAppActions();
  const { t } = useTranslation();

  const setLoading = async (isLoading: boolean) => {
    dispatch(StoreActions.setLoading(isLoading));
  };

  const loadAllStores = async (pageNo: number, pageSize: number) => {
    setLoading(true);

    const resp = await getStoreList(pageNo, pageSize);
    console.log('loadAllStores.....', resp?.data);
    if (resp.status.success) {
      dispatch(StoreActions.setStores(resp.data));

      // StoreActions.setPageInfo({
      //   currentPage: resp.data.currentPage,
      //   totalItems: resp.data.totalItems,
      //   totalPages: resp.data.totalPages,
      // } as IPageInfo);

      setLoading(false);
      return resp.data;
    } else {
      showSnackBar(SnackbarType.ERROR, resp?.status?.msg || t('error.loadStores') || '');
    }
    setLoading(false);
  };

  const resetUpdateStoreForm = () => {
    dispatch(UpdateStoreActions.resetContext());
  };
  const updateStore = async (store: IStore) => {
    setLoading(true);
    dispatch(UpdateStoreActions.setError(null));
    const resp = await postUpdateStore(store);
    console.log('updateStore.....', resp);
    if (resp.status.success && resp.data) {
      dispatch(UpdateStoreActions.setUpdated(true));
      dispatch(UpdateStoreActions.setStore(resp.data));
      setLoading(false);
      return resp.data;
    } else {
      dispatch(UpdateStoreActions.setUpdated(false));
      const msg = resp?.status?.msg || t('error.updateStore', '', store.storeName) || '';
      dispatch(UpdateStoreActions.setError({ code: '', msg }));
    }
    setLoading(false);
  };

  const deleteStore = async (store: IStore) => {
    setLoading(true);
    dispatch(UpdateStoreActions.setError(null));
    const resp = await postDeleteStore(store.id);
    console.log('deleteStore.....', resp);
    if (resp.status.success) {
      setLoading(false);
      showSnackBar(SnackbarType.SUCCESS, t('success.deleteStore', '', store.storeName));
      return resp.status.success;
    } else {
      const msg = resp?.status?.msg || t('error.deleteStore', '', store.storeName) || '';
      dispatch(UpdateStoreActions.setError({ code: '', msg }));
      showSnackBar(SnackbarType.ERROR, resp?.status?.msg || t('error.deleteStore') || '');
    }
    return false;
  };

  const loadStoreTaxes = async (storeId: number) => {
    if (storeId < 1) {
      UILogger.error('Invalid storeId to get tax');
    }
    const taxResp = await getTaxByStoreId(storeId);
    if (taxResp?.status) {
      dispatch(TaxActions.setStoreTax(taxResp.data));
    }
    return taxResp.status && taxResp.data ? taxResp.data : undefined;
  };
  const loadStoreById = async (storeId: number) => {
    if (storeId < 1) {
      UILogger.error('Invalid storeId to get store details');
    }
    const storeResp = await getStoreById(storeId);
    return storeResp.data;
  };

  const loadStoresForUser = async (userId: number, pageNo: number, pageSize: number) => {
    if (userId < 1) {
      UILogger.error('Invalid userId to get stores');
    }
    const storeResp = await getStoresForUser(userId, pageNo, pageSize);
    return storeResp.data;
  };

  const searchStores = async (criteria: IStoreSearchCriteria, pageNo: number, pageSize: number) => {
    setLoading(true);
    const storeResp = await postSearchStores(criteria, pageNo, pageSize);
    setLoading(false);
    return storeResp.data;
  };

  return {
    setLoading,
    loadAllStores,
    resetUpdateStoreForm,
    updateStore,
    deleteStore,
    loadStoreTaxes,
    loadStoreById,
    loadStoresForUser,
    searchStores,
  };
};
